import { render, staticRenderFns } from "./ChannelSingle.vue?vue&type=template&id=2dbd8562&scoped=true&"
import script from "./ChannelSingle.vue?vue&type=script&lang=js&"
export * from "./ChannelSingle.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSingle.vue?vue&type=style&index=0&id=2dbd8562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd8562",
  null
  
)

export default component.exports